import { HttpStatusCode, RestClientHttpError } from '../restClient';
import { ILoadFileRequestParams } from './types';

export async function baseLoadFileRequest(
  url: string,
  params?: ILoadFileRequestParams
): Promise<Response> {
  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: params?.headers,
      signal: params?.signal,
    });

    if (params?.onAbort) {
      params?.signal?.addEventListener('abort', () => {
        params?.onAbort?.();
      });
    }

    if (response.status !== HttpStatusCode.Ok) {
      throw new RestClientHttpError(response.status, response.statusText, url, { method: 'GET' });
    }

    return response;
  } catch (error) {
    if (error instanceof RestClientHttpError) {
      throw error;
    }
    throw new RestClientHttpError(HttpStatusCode.Unknown, error, url, {
      method: 'GET',
    });
  }
}
